import React from 'react';

import Loading from 'components/general/Loading';

import NonPropertyChannelRelationships from './NonPropertyChannelRelationships';
import { NewPropertyChannelRelationships } from './NewPropertyChannelRelationships';
import { PropertyChannelRelationships } from './PropertyChannelRelationships';
import useChannelAdminContext from 'hooks/useChannelAdminContext';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';
import { ActiveChannelTypeEnum } from 'constants-channel';

export default function ChannelRelationships() {
  const { channel } = useChannelAdminContext();
  const showNewTenantManagementView = useFlag(
    FeatureFlag.TenantManagement,
    false
  );

  if (!channel) {
    return <Loading />;
  }

  if (channel.type === ActiveChannelTypeEnum.Property) {
    if (showNewTenantManagementView && channel.parent) {
      return <NewPropertyChannelRelationships />;
    }

    return <PropertyChannelRelationships />;
  }

  return <NonPropertyChannelRelationships />;
}
